import Vue from "vue"
import Vuex from "vuex"
import { minpuroproducts } from "../firebase.config"
import firebase from "firebase"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: null, // Authentication が持っているユーザー情報
    userProfile: null, // Firestore が持っているユーザー情報
    products: [],
    lastProduct: null,
    NumberOfCards: 10,
    selectIndex: 0,
    courses: [
      { courseName: "iPhoneアプリ", selected: true },
      { courseName: "Gameアプリ", selected: true },
      { courseName: "Webサービス", selected: true },
      { courseName: "WebExpert", selected: true },
      { courseName: "VideoEditor", selected: true },
      { courseName: "UIUX", selected: true },
      { courseName: "AI", selected: true },
    ],
    areas: [
      { areaName: "東京", selected: true },
      { areaName: "京都", selected: false },
      { areaName: "福岡", selected: false },
      { areaName: "名古屋", selected: false },
      { areaName: "札幌", selected: false },
      { areaName: "仙台", selected: false },
    ],
    skills: [
      { skillName: "Swift", selected: true },
      { skillName: "C#", selected: false },
      { skillName: "HTML", selected: false },
      { skillName: "CSS", selected: false },
      { skillName: "JavaScript", selected: false },
      { skillName: "Ruby on Rails", selected: false },
      { skillName: "Figma", selected: false },
      { skillName: "Premiere Pro", selected: false },
      { skillName: "DaVinci Resolve", selected: false },
    ],
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setUserProfile(state, userProfile) {
      state.userProfile = userProfile
    },
    switchCourse(state, i) {
      state.courses[i].selected = !state.courses[i].selected
    },
    switchArea(state, i) {
      state.areas[i].selected = !state.areas[i].selected
    },
    switchSkill(state, i) {
      state.skills[i].selected = !state.skills[i].selected
    },
    selectCourse(state, index) {
      state.selectIndex = index
    },
    // fetchProductで取得したデータをstateに入れる
    setProduct(state, product) {
      state.products.push({
        id: product.id,
        course: product.data().course,
        productName: product.data().productName,
        productShortEx: product.data().productShortEx,
        url: product.data().url,
        releasedAt: product.data().releasedAt.toDate(),
      })
    },
    resetProducts(state) {
      state.products = []
    },
    setLastProduct(state, lastProduct) {
      state.lastProduct = lastProduct
    },
    increaseNumberOfCards(state) {
      state.NumberOfCards += 10
    },
    resetNumberOfCards(state) {
      state.NumberOfCards = 10
    },
  },
  actions: {
    // ログイン状態が変化するときに呼び出す
    setUserAndProfile({ commit }, { user, userProfile }) {
      commit("setUser", user)
      commit("setUserProfile", userProfile)
    },

    // firestoreからプロダクト一覧を取得
    fetchProducts({ commit }) {
      minpuroproducts
        .orderBy("releasedAt", "desc")
        .limit(10)
        .get()
        .then((snapshot) => {
          snapshot.docs.map((doc) => commit("setProduct", doc))
          commit("setLastProduct", snapshot.docs[snapshot.docs.length - 1])
        })
    },
    fetchNextProducts({ commit, state }) {
      minpuroproducts
        .orderBy("releasedAt", "desc")
        .startAfter(state.lastProduct)
        .limit(10)
        .get()
        .then((snapshot) => {
          snapshot.docs.map((doc) => commit("setProduct", doc))
          commit("setLastProduct", snapshot.docs[snapshot.docs.length - 1])
        })
    },
    fetchSpecificProducts({ commit, state }, i) {
      minpuroproducts
        .where("course", "==", state.courses[i].courseName)
        .orderBy("releasedAt", "desc")
        .limit(10)
        .get()
        .then((snapshot) => {
          snapshot.docs.map((doc) => commit("setProduct", doc))
          commit("setLastProduct", snapshot.docs[snapshot.docs.length - 1])
        })
    },
    fetchNextSpecificProducts({ commit, state }, i) {
      minpuroproducts
        .where("course", "==", state.courses[i].courseName)
        .orderBy("releasedAt", "desc")
        .startAfter(state.lastProduct)
        .limit(10)
        .get()
        .then((snapshot) => {
          snapshot.docs.map((doc) => commit("setProduct", doc))
          commit("setLastProduct", snapshot.docs[snapshot.docs.length - 1])
        })
    },
    fetchSingleProduct({ commit }, docName) {
      return new Promise((resolve) => {
        minpuroproducts
          .doc(docName)
          .get()
          .then((snapshot) => {
            commit("setProduct", snapshot)
            resolve()
          })
      })
    },
    increaseNumberOfCards({ commit }) {
      commit("increaseNumberOfCards")
    },
    resetNumberOfCards({ commit }) {
      commit("resetNumberOfCards")
    },
  },
  getters: {
    user(state) {
      return {
        ...state.user,
        ...state.userProfile,
      }
    },
  },
})
export default store

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    const userProfileRef = firebase
      .firestore()
      .collection("users")
      .doc(user.uid)
    userProfileRef.get().then((doc) => {
      let userProfile = {
        id: user.uid,
      }
      if (doc.exists) {
        userProfile = doc.data()
        userProfile.id = doc.id
      }
      store.dispatch("setUserAndProfile", {
        user,
        userProfile,
      })
    })
  } else {
    store.dispatch("setUserAndProfile", { user: null, userProfile: null })
  }
})
